import { Stack, Typography, useTheme } from "@mui/material";
import {
  CheckCircleIcon,
  InfoIcon,
  StarFilledIcon,
  TableChip,
} from "components";

const Badge = ({
  bgcolor,
  badgeText,
  icon,
}: {
  bgcolor: string;
  badgeText: string;
  icon: any;
}) => (
  <Stack
    direction="row"
    alignItems={"center"}
    p="4px 8px"
    gap="4px"
    bgcolor={bgcolor}
    borderRadius={"4px"}
  >
    {icon}
    <Typography variant="caption-xs">{badgeText}</Typography>
  </Stack>
);

export const VerifiedBadge = ({
  type = "success",
}: {
  type: "success" | "error";
}) => {
  const theme = useTheme();
  return (
    <TableChip
      containerStyle={{
        width: "fit-content",
      }}
      content={type === "success" ? "Verified" : "Verification failed"}
      type={type}
    />
  );
};

export const PrimaryEmailBadge = () => {
  const theme = useTheme();
  return (
    <Badge
      badgeText="Primary Email"
      bgcolor={theme.palette.secondary["purple-tint-3"] || ""}
      icon={
        <StarFilledIcon
          color="primary"
          sx={{
            width: "16px",
            height: "16px",
          }}
        />
      }
    />
  );
};
